import React, { useEffect } from "react";
import "./styles/App.css";
import Navbar from "./components/NavBar.tsx";
import Footer from "./components/Footer.tsx";
import AppRoutes from "./routes/AppRoutes.jsx";
import "./styles/tailwind.css";
import Titulo from "./components/head/Titulo.tsx";
import { useLocation } from "react-router-dom";

function App() {
  // noop: commit mínimo para disparar pipeline de build/deploy frontend
  const location = useLocation();
  const hideNavbar =
    location.pathname.startsWith('/catalogo') ||
    location.pathname.startsWith('/producto/') ||
    location.pathname.startsWith('/tienda/');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="App">
      <div className="min-h-screen">
        <Titulo texto={"Intercam · SocCam Web "} />
        {!hideNavbar && <Navbar />}
        <AppRoutes />
      </div>
      <Footer />
    </div>
  );
}

export default App;
